// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"869c9e9a","239":"f0008098","243":"a7df09e6","666":"ad2ad18b","886":"ef17c770"}[chunkId] + ".chunk.js";
};